import { useSearchParams } from "react-router";

import { useSession } from "./session-context";

const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

/**
 * Whose day the day view shows: `?user=<id>` for an owner looking at someone
 * else's (section 11.2), or null for the signed-in user's own. A tech's
 * `?user=` is ignored; the API would refuse it anyway (section 6.2).
 */
export function useViewedUserId(): string | null {
  const { me } = useSession();
  const [searchParams] = useSearchParams();
  const requested = searchParams.get("user");
  if (me.role !== "owner" || requested === null || !UUID.test(requested) || requested === me.id) {
    return null;
  }
  return requested;
}
